import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;

        case 'adresse':
            nextPage = 'hvordan-skete-skaden';
            break;

        case 'hvordan-skete-skaden':
            if (
                getValueOrDefault(formConfig, formValues, 'radioSkyldesskadenoversvmmelsefrahavsellerbk').value === 'Ja'
            ) {
                nextPage = 'om-vandet';
            } else {
                nextPage = 'hvor-kom-vandet-fra';
            }
            break;

        case 'om-vandet':
            nextPage = 'beskriv-skaden';
            break;

        case 'beskriv-skaden':
            nextPage = 'kortslutning';
            break;

        case 'kortslutning':
            if (
                getValueOrDefault(formConfig, formValues, 'erderiforbindelsemedskadensketkortslutning').value === 'Ja'
            ) {
                nextPage = 'kortslutning-hvor';
            } else {
                nextPage = 'skade-paa-ting';
            }
            break;

        case 'kortslutning-hvor':
            nextPage = 'skade-paa-ting';
            break;

        case 'skade-paa-ting':
            if (getValueOrDefault(formConfig, formValues, 'erderogssketskadepdineting').value === 'Ja') {
                nextPage = 'vaerdi-af-ting';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        case 'vaerdi-af-ting':
            nextPage = 'dokumentation';
            break;

        case 'hvor-kom-vandet-fra':
            nextPage = 'aarsag-til-skaden';
            break;

        case 'aarsag-til-skaden':
            nextPage = 'vand-eller-fugt';
            break;

        case 'vand-eller-fugt':
            if (
                getValueOrDefault(formConfig, formValues, 'erderstadigvandellerfugtibygningen').value ===
                'jaDerErStadigVand'
            ) {
                nextPage = 'skadeservice';
            } else if (
                getValueOrDefault(formConfig, formValues, 'erderstadigvandellerfugtibygningen').value ===
                'jaBygningenErFugtig'
            ) {
                nextPage = 'skadeservice-2';
            } else if (
                getValueOrDefault(formConfig, formValues, 'erderstadigvandellerfugtibygningen').value === 'nej'
            ) {
                nextPage = 'udbedring-af-skaden';
            } else {
                nextPage = 'firmaoplysninger-3';
            }
            break;

        case 'skadeservice':
            if (
                getValueOrDefault(formConfig, formValues, 'hardukontaktetenhndvrkerelleretskadeservicefirma').value ===
                'ja'
            ) {
                nextPage = 'firmaoplysninger';
            } else {
                nextPage = 'beskriv-skaden-2';
            }
            break;

        case 'firmaoplysninger':
            nextPage = 'beskriv-skaden-2';
            break;

        case 'skadeservice-2':
            if (
                getValueOrDefault(formConfig, formValues, 'hardukontaktetenhndvrkerelleretskadeservicefirma2').value ===
                'ja'
            ) {
                nextPage = 'firmaoplysninger-2';
            } else {
                nextPage = 'beskriv-skaden-2';
            }
            break;

        case 'firmaoplysninger-2':
            nextPage = 'beskriv-skaden-2';
            break;

        case 'udbedring-af-skaden':
            if (
                getValueOrDefault(
                    formConfig,
                    formValues,
                    'vilduselvstforudbedringafskadenfxrengringogevtSkaderpbygningen'
                ).value === 'ja'
            ) {
                nextPage = 'erstatning';
            } else {
                nextPage = 'beskriv-skaden-2';
            }
            break;

        case 'erstatning':
            nextPage = 'beskriv-skaden-2';
            break;

        case 'firmaoplysninger-3':
            nextPage = 'beskriv-skaden-2';
            break;

        case 'beskriv-skaden-2':
            nextPage = 'skade-paa-ting-2';
            break;

        case 'skade-paa-ting-2':
            if (getValueOrDefault(formConfig, formValues, 'erderogssketskadepdineting2').value === 'ja') {
                nextPage = 'hvad-er-oedelagt';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        case 'hvad-er-oedelagt':
            nextPage = 'erstatning-ting';
            break;

        case 'erstatning-ting':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation':
            nextPage = 'om-dig';
            break;

        case 'om-dig':
            nextPage = 'anden-forsikring';
            break;

        case 'anden-forsikring':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilken-forsikring';
            } else {
                nextPage = 'resume';
            }
            break;

        case 'hvilken-forsikring':
            nextPage = 'resume';
            break;

        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
